import React, { Component } from 'react'
import { connect } from 'react-redux'
import { GettingStarted } from '../../components'
import {
  selectCurrentPhoneId,
  selectCurrentPhone,
  selectLanguage,
  selectPreSaleFlag
} from '../App/selectors'
import {
  selectStarterContent,
  selectStarterContentFetching,
  selectCurrentPhoneStarterContentId
} from './selectors'
import { fetchStartContent } from './actions'
import { createEvent } from '../UserEvents/actions'

class GettingStartedContainer extends Component {
  componentDidMount() {
    const {
      currentPhoneId,
      currentPhoneStarterContentId,
      startercontent,
      fetchStartContent
    } = this.props

    if (
      currentPhoneId !== currentPhoneStarterContentId ||
      startercontent.length === 0
    ) {
      fetchStartContent(currentPhoneId)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { currentPhoneId, fetchStartContent } = this.props

    if (currentPhoneId !== nextProps.currentPhoneId) {
      fetchStartContent(nextProps.currentPhoneId)
    }
  }

  render() {
    const {
      currentPhone,
      startercontent,
      query,
      createUserEvent,
      preSaleFlag
    } = this.props

    return (
      <GettingStarted
        currentPhone={currentPhone}
        startercontent={startercontent}
        query={query}
        createUserEvent={createUserEvent}
        preSaleFlag={preSaleFlag}
      />
    )
  }
}

const mapStateToProps = state => ({
  currentPhone: selectCurrentPhone(state),
  language: selectLanguage(state),
  currentPhoneId: selectCurrentPhoneId(state),
  preSaleFlag: selectPreSaleFlag(state),
  startercontent: selectStarterContent(state),
  isFetching: selectStarterContentFetching(state),
  currentPhoneStarterContentId: selectCurrentPhoneStarterContentId(state),
  query: state.routing.locationBeforeTransitions.query
})

const mapDispatchToProps = dispatch => ({
  fetchStartContent: currentPhoneId =>
    dispatch(fetchStartContent.request(currentPhoneId)),
  createUserEvent: event => dispatch(createEvent(event))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GettingStartedContainer)



// WEBPACK FOOTER //
// ./src/containers/GettingStarted/GettingStarted.js